import React, {Component} from 'react'
import ReactTable from "react-table";
import { Redirect } from 'react-router-dom'
import * as config from '../../Configuration/Config.js'
import UserProfile from '../../Configuration/UserProfile.js'

class FoldersGrid extends Component {
    constructor() {
        super();
        
        this.handleNew = this.handleNew.bind(this)        
        this.handleBack = this.handleBack.bind(this)       

        this.state = {
            is_loaded: false,
            redirect_new: false,
            redirect_back: false,
            customer_id: 0,
            folders: []
        }
    }

    setRedirectNew() {
        this.setState({redirect_new: true});
    }

    setRedirectBack() {
        this.setState({redirect_back: true});
    }

    componentDidMount() {  
        const customer_id = this.props.match.params.cid;
        
        var that = this;        
        
        let uri = config.getAcumenAPIURL('customer/' + customer_id + '/folders');        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
        myHeaders.append("table-prefix", config.getTablePrefix());

        fetch(uri, {
            method: 'get',
            headers: myHeaders
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            console.log('folders loaded')
            that.setState({ is_loaded: true, customer_id: customer_id, folders: data.folders });
        });
        
    }

    handleNew(event) {
        event.preventDefault();

        this.setRedirectNew();
    }

    handleBack(event) {
        event.preventDefault();

        this.setRedirectBack();        
    }

    render() {        
        if (this.state.is_loaded === false) {
            return <div></div>
        }
        const customer_id = this.state.customer_id;
        if (customer_id === 0){
            return <div>No customer provided</div>
        }        
        if (this.state.redirect_new){
            return <Redirect to={'/cw/folders/' + customer_id + '/new'} />
        }        
        const profile = new UserProfile();                
        if (this.state.redirect_back){
            return <Redirect to='/cw' />
        }

        const folders = this.state.folders;

        return <div className="grid-wrapper">
                    <div className="center-div">
                        <h1>myAcumen - Folders</h1>                        
                    </div>
                    <div className="addNewButton">
                        <button className="btn btn-primary" onClick={this.handleNew}>Add New Folder</button>
                         &nbsp;&nbsp;
                        <button className="btn btn-primary" onClick={this.handleBack}>Back to myAcumen</button>
                    </div>
                    <div className="ReactTableCenter">                
                    <ReactTable
                            data={folders}
                            minRows="0"
                            columns={[
                                {
                                    accessor: "id",
                                    width: 100,
                                    resizable: false,
                                    Header: "Edit",
                                    style: { textAlign: "center"},
                                    Cell: row=>(

                                        <div className="gridButton">
                                        <a href={'/cw/folders/' + customer_id + '/' + row.value} className="btn btn-success cwedit" role="button">EDIT</a>                                        
                                    </div>                                        
                                    )
                                },
                                {
                                    Header: "Folder Name",
                                    accessor: "folder_name",
                                    Cell: row=>(
                                    <div className="gridValue">
                                        {row.original.folder_name}
                                    </div>
                                )
                                }
                            ]}
                            //defaultPageSize={15}
                            defaultSorted={[
                                {
                                    id: "folder_name",
                                    desc: false
                                }
                            ]}
                            defaultPageSize={folders.length}
                            showPagination={false}
                            className="-striped -highlight"
                        >
                        </ReactTable>

                    </div>
                </div>
                
    }
}

export default FoldersGrid


// WEBPACK FOOTER //
// ./src/Components/CW/folders/FoldersGrid.js